module.exports = __webpack_public_path__ + "img/BlackMirror.70271df5.webp";